module.exports = __webpack_public_path__ + "img/service1-01.f708b1f5.png";